import $ from "jquery";

const news = (scroll) => {
    $('.news').each(function () {
        const $newsSection = $(this);
        $newsSection.find('.news__list').hide().eq(1).slideDown();
    });

    $('.news__categories a').on('click', function (e) {
        e.preventDefault();

        const $this = $(this);
        const $newsSection = $this.closest('.news');
        const $newsList = $newsSection.find('.news__list');
        const index = $this.parent().index();

        if (!$this.hasClass('active')) {
            $newsSection.find('.news__categories a.active').removeClass('active');
            $this.addClass('active');

            $newsList.filter(':visible').slideUp(() => {
                scroll.update();
                $newsList.removeClass('active'); 
            });
            
            $newsList.eq(index).slideDown(() => {
                scroll.update();
                $newsList.eq(index).addClass('active'); 
            });
            
        }
    });

    $('.btn--scroll-open').on('click', function (e) {
        e.preventDefault();
    
        const buttonIndex = $(this).index('.btn--scroll-open');
    
        const target = $('.news__list').eq(buttonIndex);
    
        if (target.length) {
            $('.news__list').slideUp(() => {
                scroll.update();
                $('.news__list').removeClass('active'); 
                $('.news__categories a.active').removeClass('active');
            });
    
            target.slideDown(() => {
                scroll.update();
                target.addClass('active');
                $('.news__categories a').eq(buttonIndex).addClass('active');
                scroll.scrollTo(target[0]); 
            });
        }
    });
    
    
    const currentNewsItem = $('.news__list.active .news__item')

    if ($('.news__list.active')) {
        if (currentNewsItem.length > 4) {
            currentNewsItem.slice(4).hide();
            $('.news__more').click(function (e) {
                e.preventDefault();
            
                const news = $('.news'); 
                const newsList = $('.news__list.active');
                const currentNewsItem = newsList.find('.news__item'); 
                const hiddenItems = newsList.find('.news__item:hidden');
            
                if (hiddenItems.length > 0) {
                    hiddenItems.slideDown(function () {
                        scroll.update(); 
                    });
            
                    $('.news__more').html('<span class="icon-plus"></span> Show Less News');
                    $('.news__more .icon-plus').addClass('active');
                } else {
                    scroll.scrollTo(news[0]);

                    setTimeout(() => {
                        currentNewsItem.slice(4).slideUp(function () {
                            scroll.update();
                        });
    
                        $('.news__more').html('<span class="icon-plus"></span> See All the News');
                        $('.news__more .icon-plus').removeClass('active');
                    }, 700);
                }
            });
            
        }
    }

};

export default news;
